import React from "react";
import List from "@mui/material/List";
import ListItem from '@mui/material/ListItem';
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import Feature from './../admin/Feature';
import "./Menu.css";

// Import common MUI icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import MessageIcon from '@mui/icons-material/Message';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CampaignIcon from '@mui/icons-material/Campaign';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import EmailIcon from '@mui/icons-material/Email';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PersonIcon from '@mui/icons-material/Person';
import SecurityIcon from '@mui/icons-material/Security';
import StorageIcon from '@mui/icons-material/Storage';
import WebIcon from '@mui/icons-material/Web';
import CodeIcon from '@mui/icons-material/Code';
import BuildIcon from '@mui/icons-material/Build';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';
import HomeIcon from '@mui/icons-material/Home';
import ListIcon from '@mui/icons-material/List';
import ViewListIcon from '@mui/icons-material/ViewList';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import GroupIcon from '@mui/icons-material/Group';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import TimelineIcon from '@mui/icons-material/Timeline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventIcon from '@mui/icons-material/Event';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TaskIcon from '@mui/icons-material/Task';
import WorkIcon from '@mui/icons-material/Work';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SupportIcon from '@mui/icons-material/Support';
import HeadsetIcon from '@mui/icons-material/Headset';
import ChatIcon from '@mui/icons-material/Chat';
import ForumIcon from '@mui/icons-material/Forum';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import FeedbackIcon from '@mui/icons-material/Feedback';
import RateReviewIcon from '@mui/icons-material/RateReview';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import FlagIcon from '@mui/icons-material/Flag';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import BlockIcon from '@mui/icons-material/Block';
import LockIcon from '@mui/icons-material/Lock';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CreateIcon from '@mui/icons-material/Create';
import SaveIcon from '@mui/icons-material/Save';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SyncIcon from '@mui/icons-material/Sync';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import GridOnIcon from '@mui/icons-material/GridOn';
import TableChartIcon from '@mui/icons-material/TableChart';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import MemoryIcon from '@mui/icons-material/Memory';
import DnsIcon from '@mui/icons-material/Dns';
import RouterIcon from '@mui/icons-material/Router';
import WifiIcon from '@mui/icons-material/Wifi';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalWifi4BarIcon from '@mui/icons-material/SignalWifi4Bar';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import SpeedIcon from '@mui/icons-material/Speed';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import NumbersIcon from '@mui/icons-material/Numbers';
import RouteIcon from '@mui/icons-material/Route';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyIcon from '@mui/icons-material/Money';

// Icon mapping function
const getMuiIcon = (iconName) => {
  const iconMap = {
    // Dashboard & Navigation
    'dashboard': DashboardIcon,
    'home': HomeIcon,
    'list': ListIcon,
    'view_list': ViewListIcon,
    'folder': FolderIcon,
    'description': DescriptionIcon,
    
    // People & Users
    'people': PeopleIcon,
    'person': PersonIcon,
    'group': GroupIcon,
    'supervisor_account': SupervisorAccountIcon,
    'account_circle': AccountCircleIcon,
    
    // Business & Commerce
    'business': BusinessIcon,
    'business_center': BusinessCenterIcon,
    'store': StoreIcon,
    'shopping_cart': ShoppingCartIcon,
    'local_shipping': LocalShippingIcon,
    'account_balance': AccountBalanceIcon,
    'receipt': ReceiptIcon,
    'payment': PaymentIcon,
    'credit_card': CreditCardIcon,
    'precision_manufacturing': PrecisionManufacturingIcon,
    'numbers': NumbersIcon,
    'route': RouteIcon,
    'attach_money': AttachMoneyIcon,
    'money': MoneyIcon,
    'receipt': ReceiptIcon,

    // Communication
    'phone': PhoneIcon,
    'message': MessageIcon,
    'email': EmailIcon,
    'chat': ChatIcon,
    'forum': ForumIcon,
    'question_answer': QuestionAnswerIcon,
    'contact_phone': ContactPhoneIcon,
    'notifications': NotificationsIcon,
    
    // Analytics & Reports
    'assessment': AssessmentIcon,
    'analytics': AnalyticsIcon,
    'trending_up': TrendingUpIcon,
    'bar_chart': BarChartIcon,
    'pie_chart': PieChartIcon,
    'timeline': TimelineIcon,
    
    // Campaigns & Marketing
    'campaign': CampaignIcon,
    'schedule': ScheduleIcon,
    'event': EventIcon,
    'calendar_today': CalendarTodayIcon,
    
    // Tasks & Work
    'assignment': AssignmentIcon,
    'task': TaskIcon,
    'work': WorkIcon,
    'robot': SmartToyIcon,
    'brain': PsychologyIcon,
    
    // Support & Help
    'support': SupportIcon,
    'headset': HeadsetIcon,
    'help': HelpIcon,
    'info': InfoIcon,
    'feedback': FeedbackIcon,
    'rate_review': RateReviewIcon,
    
    // Status & Actions
    'star': StarIcon,
    'favorite': FavoriteIcon,
    'thumb_up': ThumbUpIcon,
    'thumb_down': ThumbDownIcon,
    'flag': FlagIcon,
    'warning': WarningIcon,
    'error': ErrorIcon,
    'check_circle': CheckCircleIcon,
    'cancel': CancelIcon,
    'block': BlockIcon,
    
    // Security & Access
    'security': SecurityIcon,
    'lock': LockIcon,
    'vpn_key': VpnKeyIcon,
    'visibility': VisibilityIcon,
    'visibility_off': VisibilityOffIcon,
    
    // CRUD Operations
    'edit': EditIcon,
    'delete': DeleteIcon,
    'add': AddIcon,
    'remove': RemoveIcon,
    'create': CreateIcon,
    'save': SaveIcon,
    
    // Data & Files
    'download': DownloadIcon,
    'upload': UploadIcon,
    'cloud_upload': CloudUploadIcon,
    'cloud_download': CloudDownloadIcon,
    'sync': SyncIcon,
    'refresh': RefreshIcon,
    
    // Search & Filter
    'search': SearchIcon,
    'filter_list': FilterListIcon,
    'sort': SortIcon,
    
    // Views & Layout
    'view_module': ViewModuleIcon,
    'grid_on': GridOnIcon,
    'table_chart': TableChartIcon,
    
    // Technology & Infrastructure
    'storage': StorageIcon,
    'memory': MemoryIcon,
    'data_usage': DataUsageIcon,
    'dns': DnsIcon,
    'router': RouterIcon,
    'wifi': WifiIcon,
    'signal_cellular_alt': SignalCellularAltIcon,
    'signal_wifi_4_bar': SignalWifi4BarIcon,
    'network_check': NetworkCheckIcon,
    'speed': SpeedIcon,
    
    // Settings & Configuration
    'settings': SettingsIcon,
    'build': BuildIcon,
    'code': CodeIcon,
    'web': WebIcon,
    'admin_panel_settings': AdminPanelSettingsIcon,
    
    // Default fallback
    'default': DashboardIcon
  };
  
  return iconMap[iconName] || iconMap['default'];
};

function SidebarItem({ depthStep = 40, depth = 0, expanded, item, activeItem, onItemClick, ...rest }) {
  const { label, location, items, icon, Icon, onClick: onClickProp } = item;
  
  // Check if this item is currently active/expanded
  const isActive = activeItem === item.name;
  
  // Get MUI icon component
  const MuiIconComponent = Icon || (icon ? getMuiIcon(icon) : null);
  
  function toggleCollapse() {
    if (Array.isArray(items) && items.length) {
      // If this item is already active, collapse it
      if (isActive) {
        onItemClick(null);
      } else {
        // Otherwise, make this item active (which will collapse others)
        onItemClick(item.name);
      }
    }
  }

  function onClick(e) {
    if (Array.isArray(items) && items.length) {
      toggleCollapse();
    }
    if (onClickProp) {
      onClickProp(e, item);
    }
  }

  let expandIcon;

  if (Array.isArray(items) && items.length) {
    expandIcon = isActive ? (
      <ExpandLessIcon
        className={
          "sidebar-item-expand-arrow" + " sidebar-item-expand-arrow-expanded"
        }
      />
    ) : (
      <ExpandMoreIcon className="sidebar-item-expand-arrow" />
    );
  }

  return (
    <div>
      {item.feature ? (
      <Feature name={item.feature}>
        <ListItem
          className="sidebar-item"
          onClick={onClick}
          button
          {...rest}
        >
          <div
            style={{ paddingLeft: depth * depthStep }}
            className="sidebar-item-content"
          >
            {MuiIconComponent && <MuiIconComponent className="sidebar-item-icon" fontSize="small" />}
            <div className="sidebar-item-text">
              <Link to={location} className="nav-link">{label}</Link>
            </div>
          </div>
          {expandIcon}
        </ListItem>
      </Feature>
      ) : (
         <ListItem
        className="sidebar-item"
        onClick={onClick}
        button
        {...rest}
      >
        <div
          style={{ paddingLeft: depth * depthStep }}
          className="sidebar-item-content"
        >
          {MuiIconComponent && <MuiIconComponent className="sidebar-item-icon" fontSize="small" />}
          <div className="sidebar-item-text">
            <Link to={location} className="nav-link">{label}</Link>
          </div>
        </div>
        {expandIcon}
      </ListItem>
      )}
      <Collapse in={isActive} timeout="auto" unmountOnExit>
        {Array.isArray(items) ? (
          <List disablePadding>
            {items.map((subItem, index) => (
              <React.Fragment key={`${subItem.name}${index}`}>
                {subItem === "divider" ? (
                  <Divider style={{ margin: "6px 0" }} />
                ) : (
                  <SidebarItem
                    depth={depth + 1}
                    depthStep={depthStep}
                    item={subItem}
                    activeItem={activeItem}
                    onItemClick={onItemClick}
                  />
                )}
              </React.Fragment>
            ))}
          </List>
        ) : null}
      </Collapse>
    </div>
  );
}

function Menu({ items, depthStep, depth, expanded, feature }) {
  const [activeItem, setActiveItem] = React.useState(null);

  const handleItemClick = (itemName) => {
    setActiveItem(itemName);
  };

  return (
    <div className="sidebar">
      <List disablePadding dense>
        {items.map((sidebarItem, index) => (
          <React.Fragment key={`${sidebarItem.name}${index}`}>
            {sidebarItem === "divider" ? (
              <Divider style={{ margin: "6px 0" }} />
            ) : (
              <SidebarItem
                depthStep={depthStep}
                depth={depth}
                expanded={expanded}
                item={sidebarItem}
                activeItem={activeItem}
                onItemClick={handleItemClick}
              />
            )}
          </React.Fragment>
        ))}
      </List>
    </div>
  );
}

export default Menu;
